import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cjayhkab: FaireBrandEntity = {
  token: "b_cjayhkab",
  type: "brand",
  name: "Just Bee & Me Greeting Cards",
  avatarUrl:
    "https://cdn.faire.com/fastly/8b081c6a59b584fcb146407c304d1e1a910243e3c73f3f9aa66e419583e265b6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/db08c5c6f0dc2810fdd78274d0cb0c9ad14af7a42bb9f4147c6a7dfd8f7b2ca4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8b081c6a59b584fcb146407c304d1e1a910243e3c73f3f9aa66e419583e265b6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/db08c5c6f0dc2810fdd78274d0cb0c9ad14af7a42bb9f4147c6a7dfd8f7b2ca4.jpeg",
  location: "Pembroke, MA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "In 2010, I was working on an idea for a garden themed gallery show, when suddenly the ‘bees’ kept crossing my path and entering my life daily. Walking my dog one day, a bee literally buzzed directly in front of my eyes and the image of a cute little zen bee meditating came to me...‘Bee In The Moment’ was born. All of my worlds and experience seemed to magically collide at that time. The image of my father, who taught me to draw, letting bumble bees crawl across his hands when I was a little girl, to show me not to be afraid. My passion for yoga, illustration, nature and environmental concerns, it all came together. I would create a line of inspirational, yet whimsical greeting cards with cute little bees doing silly things, like yoga poses. With the yearning to use my talent in creating artwork that would touch people’s lives and ‘make a difference’, I would use recycled paper, biodegradable packaging and donate a portion of my proceeds to the ‘Save The Honeybee Foundation’. \n\nThe inspiration and ideas have not stopped flowing, the cards and other eco products are touching so many people’s lives all over the country and this journey has been nothing but positive. You know you are fulfilling your life's ‘purpose’, when you get chills every time you share your idea with someone. It was all ‘meant to bee’. Bee The Change with us. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:10.032Z",
    importedBy: "entity-db-cli",
  },
};
